import { Flex } from '@sequencehq/core-components'
import {
  DeferredRevenueDashboardTable,
  DeferredRevenueTableGroupBy
} from './DeferredRevenueDashboardTable'
import type { Control } from '../DeferredRevenueDashboard.root'

type Props = {
  asOfDate: Control<Date>
  groupBy: Control<DeferredRevenueTableGroupBy>
}

export const DeferredRevenueDashboardContent = ({
  asOfDate,
  groupBy
}: Props) => {
  return (
    <Flex flexDirection="column" height="100%">
      <DeferredRevenueDashboardTable
        asOfDate={asOfDate.value}
        setAsOfDate={asOfDate.onChange}
        groupBy={groupBy.value}
        setGroupBy={groupBy.onChange}
      />
    </Flex>
  )
}
